import React from "react";
import {TableContext,RowContext,TableOperation, TableV2} from "@q4us-sw/q4us-ui/lib/TableV2";
import {
    getFeConfig,
    uploadGeneralContract,
    visualize,
    fetchPreviousGeneralContract,
    fetchGeneralContract,
    replaceGeneralContract,
    deleteGeneralContract,
    updateGeneralContract
} from "../api/api";
import {Button, Modal, Upload, Space, Typography, notification} from "antd";
import '../styles/GenralContractDocuments.css'
import {Form} from "@q4us-sw/q4us-ui";
import {
    InboxOutlined,
    CloudDownloadOutlined,
    UploadOutlined,
} from '@ant-design/icons'
import {unstable_batchedUpdates} from "react-dom";

const DownloadReplaceComponent = (props) => {
    const {row, index} = props;
    const filename = row.name


    return <TableContext.Consumer>
       { table => <Space direction={'horizontal'} key={index}>
           {row.isreplaced && <Button icon={<CloudDownloadOutlined />} style={{color: 'grey'}} onClick={async () => {
               await fetchPreviousGeneralContract(row.id);
           }}/>}
           <Button icon={<CloudDownloadOutlined />} style={{color: 'green'}} onClick={async () => {
            await fetchGeneralContract(row.id, row.name);
        }}/>

        <Upload
            progress={{
                showInfo: false
            }}
            fileList={[]}
            customRequest={async ({ file, onSuccess })=>{
                props.table?.setLoading(true)
                const formData = new FormData();
                const name = file.name
                formData.append(row.id, file);
                const res = await replaceGeneralContract(formData, name);
                const {status} = res;

                if(status === 200){
                    const tableData = await table?.props.fetchData({schema: table?.props.schema}) || {};
                    notification.success({message: `File replaced successfully`})
                    unstable_batchedUpdates(() => {
                        table?.setData(tableData.data?.rows || [])
                        table?.setLoading(false)
                    })
                    onSuccess(res.data, res.request)
                }else{
                    notification.error({message: `File replace failed`})
                    table?.setLoading(false)
                }
            }}
        >
            <Button icon={<UploadOutlined />}>Replace</Button>
        </Upload>
    </Space>}
    </TableContext.Consumer>
}


const UploadItem = ({value, onChange})=>{

    return <Upload.Dragger
        maxCount={1}
        fileList={value ? [value]: []}
        progress={{
            showInfo: false
        }}
        onRemove={()=>onChange(undefined)}
        customRequest={(opt)=>{
            onChange(opt.file)
            opt.onSuccess()
        }}>
        <p className="ant-upload-drag-icon">
            <InboxOutlined />
        </p>
        <p className="ant-upload-text">Click or drag file to this area to upload</p>
    </Upload.Dragger>
}


export const GeneralContractForm = ({onSubmit, onCancel}) => {

    return <TableContext.Consumer>
        {
            table => <Form
                maxHeight={`60vh`}
                schema={`contract_document`}

                config={async (schema) => {
                    const {data: {rows = []} = {}} = await getFeConfig(schema) || {}
                    return rows;
                }}

                visibilityValidator={(schema, {name}, form) => {
                    if (schema === 'contract_document') {
                        return name !== 'sort_number'&& name !== 'date_of_upload' && name !== 'date_of_change'
                    }
                    return true;
                }}
                overrideComponent={(schema, element)=>{
                    if(schema === 'contract_document'){
                        if(element.name === 'file'){
                            return <UploadItem key={`file`}/>
                        }
                    }
                }}

                rejected={()=>onCancel()}
                submit={async (values) => {
                    table?.setLoading(true)
                    const {file, document_name} = values
                    const formData = new FormData();

                    formData.append(document_name,file);
                    const res = await uploadGeneralContract(formData)
                    const {status} = res
                    if(status === 200){
                        const tableData = await table?.props.fetchData({schema: table?.props.schema}) || {};
                        notification.success({message: `File uploaded successfully`})
                        unstable_batchedUpdates(() => {
                            table?.setData(tableData.data?.rows || [])
                            table?.setLoading(false)
                        })
                    }else{
                        notification.error({message: `File upload failed`})
                        table?.setLoading(false)
                    }
                    return await onSubmit()
                }}/>
        }
    </TableContext.Consumer>
};


export const GeneralContractDocuments = (props) => {

    const [open,setOpen] = React.useState(false)

    return <div className={`general-contract-content`}>
        <TableV2
            header={<div className={`general-contract-header`}>
                <Typography.Title level={3}>General Contract Documents</Typography.Title>
                <div className={`spacer`}/>
                <Button onClick={()=>setOpen(true)}>Add New Document</Button>
            </div>}
            shouldRefresh={(operation, status)=> {return operation === TableOperation.Update | TableOperation.Delete}}
            fetchConfig={async (schema) => {
                const {data= {}} = await getFeConfig('contract_document')
                const { statusCode, rows = []} = data;

                const rows2 = rows.map( x=> {
                    if(x.name === 'file'){
                        const formatter = (row,table, tableData) =>{
                            const filename= row.name;
                            return DownloadReplaceComponent({row}, table, tableData, filename);
                        }
                        return {...x, formatter}
                    }
                    return x
                })

                return { data: { statusCode, rows: rows2 } };
            }}
            fetchData={async (request) => {
                return await visualize("general_contract_document")
            }}
            action={{
                title: 'Action',
                options: TableOperation.Update | TableOperation.Delete,
                minWidth: 45
            }}
            saveData={async (data) => {
                const { data: { statusCode = 400, rows = [] } = {} } = await updateGeneralContract(data, 'general_contract_document');
                return { data: { statusCode, rows: [data] } };
            }}
            deleteData={async (data) => {
                const res = await deleteGeneralContract(data.id);
                if(res.status === 200){
                    notification.success({message: `File [${data.document_name}] deleted`})
                    return true
                }else{
                    notification.error({message: `File [${data.document_name}] delete failed`})
                }
            }}
            scroll={{y: 'calc(90vh - 40px)', x: 'max-content' }}
        >
            <Modal
                onCancel={() => setOpen(false)}
                footer={null}
                closable={true}
                title={'Add General Contract Document'}
                visible={open}
            >
                <GeneralContractForm onCancel={()=>setOpen(false)} onSubmit={()=> {
                    setOpen(false)
                    return true;
                }}/>
            </Modal>
        </TableV2>
    </div>
}
